export default __webpack_public_path__ + "static/media/restaurantpic.4b7c089c.png";